// extracted by mini-css-extract-plugin
module.exports = {"accessDeniedTitle":"AccessDenied_accessDeniedTitle__JGk82","accessDeniedContent":"AccessDenied_accessDeniedContent__Mn8kG","signInLink":"AccessDenied_signInLink__HbpUA"};